import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { EM_DASH } from 'libs.constants';
import { useLocalizeMessage } from 'libs.nucleus';
import { escapeNonBreakingSpaces } from '../../../helpers/ecoa.format.helpers';
import { substituteVariablesInString } from '../../../helpers/step_response_variable.helpers';
export const usePIOversightDetailsTableColumns = () => {
    const translate = useLocalizeMessage();
    const resolveVariables = useCallback((input, variables) => {
        const normalized = Array.isArray(input) ? input.join(', ') : String(input ?? EM_DASH);
        return escapeNonBreakingSpaces(substituteVariablesInString(normalized, variables));
    }, [translate]);
    const dcrItemsTableColumns = useMemo(() => {
        return [
            {
                header: translate('label.pi_oversight.review.activity'),
                accessorKey: 'activity',
                cell: (context) => {
                    const value = context.row.original.activity;
                    return _jsx("span", { className: 'text-text-secondary', children: value });
                },
            },
            {
                header: translate('label.pi_oversight.review.question'),
                accessorKey: 'question',
                cell: (context) => {
                    const value = context.row.original.question;
                    const resolvedQuestion = escapeNonBreakingSpaces(String(value ?? EM_DASH));
                    return _jsx("span", { className: 'text-text-secondary', children: resolvedQuestion });
                },
            },
            {
                header: translate('label.pi_oversight.review.old_response'),
                accessorKey: 'oldResponse',
                cell: (context) => {
                    const value = String(context.row.original.oldValue);
                    return _jsx("span", { className: 'font-semibold', children: value ?? EM_DASH });
                },
            },
            {
                header: translate('label.pi_oversight.review.new_response'),
                accessorKey: 'newResponse',
                cell: (context) => {
                    const value = String(context.row.original.newValue);
                    return _jsx("span", { className: 'font-semibold', children: value ?? EM_DASH });
                },
            },
            {
                header: translate('label.pi_oversight.review.reason_for_change'),
                accessorKey: 'reasonForChange',
                cell: (context) => {
                    const value = context.row.original.reason;
                    return _jsx("span", { className: 'text-text-secondary', children: value ?? EM_DASH });
                },
            },
        ];
    }, []);
    const taskResponsesTableColumns = useMemo(() => {
        return [
            {
                header: translate('generic.question'),
                accessorKey: 'question',
                cell: (context) => {
                    const { question_text, name: screenName, variables } = context.row.original;
                    const rawText = question_text || screenName;
                    const resolvedQuestion = resolveVariables(rawText, variables);
                    return _jsx("div", { className: 'text-sm text-text-secondary', children: resolvedQuestion });
                },
            },
            {
                header: translate('generic.responses', { count: 1 }),
                accessorKey: 'response',
                cell: (context) => {
                    const { value, variables } = context.row.original;
                    const resolvedResponse = resolveVariables(value, variables);
                    return _jsx("span", { className: 'text-sm text-text-secondary', children: resolvedResponse });
                },
            },
        ];
    }, []);
    return {
        dcrItemsTableColumns,
        taskResponsesTableColumns,
    };
};
